import { render } from "./BIMPLUSItemRowDetails.vue?vue&type=template&id=05a989e2"
import script from "./BIMPLUSItemRowDetails.vue?vue&type=script&lang=js"
export * from "./BIMPLUSItemRowDetails.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__